// Hooks
import useApi from "../useApi"

// Utils & misc
import { FID_HOSTNAME } from "../../../constants/constants"

const useFidTargets = () => {
  const [, , , , rawRequest] = useApi()

  const AUTHORIZATION = "X-Authorization"
  const BASE_URL = `https://${FID_HOSTNAME}/api/v1`

  const getFidTargets = () => {
    return rawRequest("GET", `${BASE_URL}/targets`, null, {
      authKey: AUTHORIZATION,
    })
  }

  return [
    {
      getFidTargets,
    },
  ]
}

export default useFidTargets
